import React from 'react';
import {getIndexProtectorLabel} from "../../shared/common";
import {connect} from "react-redux";
import classes from './Glossary.css';

const glossary = (props) => {

    const indexProtector = props.indexProtector ? props.indexProtector : 5;
    const isIAAndIAA = indexProtector.indexOf("INDEX ACHIEVER") !== -1 ? true : false;
    let is55MVA7 = false;
    switch(props.indexProtector.toString()) {
        case "7":
            is55MVA7 = true;
            break;
        case "5":
            is55MVA7 = true;
            break;
        case "5 MVA":
            is55MVA7 = true;
            break;
    }

    let notForWellsFargoContent;
    let label1;
    let label2;
    let label3;
    let label4;
    let label5;

    if(props.companyName !== "WELLS_FARGO") {
        notForWellsFargoContent = (
            <React.Fragment>
                {(!isIAAndIAA && props.indexProtector != 5) && (
                    <React.Fragment>
                        <li>
                            S&P 500 Risk Control 10% Index – Seeks to track the investment results of an index
                            composed of large-cap equities of the 500 leading companies but exposure is dynamically
                            rebalanced based on observed S&P 500 historic volatility to maintain a 10% volatility
                            targets.
                        </li>
                        <li>
                            S&P U.S. Retiree Spending Index – Seeks to track the investment results of an index
                            composed of equities in economic sectors that are affected by retiree spending, such as
                            healthcare, entertainment, and leisure.
                        </li>
                    </React.Fragment>
                )}
                {props.indexProtector != 5 &&  <li>
                    iShares U.S. Real Estate ETF – Seeks to track the investment results of an index
                    composed of U.S. equities in the real estate sector
                </li>}
            </React.Fragment>
        );

        label1 = (
            <React.Fragment>by either a <b>cap</b> or <b>{isIAAndIAA ? "upside" : ""} participation rate.</b></React.Fragment>
        );

        label2 = (
            <p>
                {!isIAAndIAA && (
                <b>
                    The S&P 500 Risk Control 10% Index refers to the S&P 500 Average Daily Risk Control 10%
                    USD Price Return Index. For more information, visit US.SPIndices.com and search keyword
                    SPXAV10P. For more information on the S&P U.S. Retiree Spending Index, visit
                    US.SPIndices.com and search keyword SPRETIRE. For more information on the iShares U.S.
                    Real Estate ETF, visit iShares.com and search ticker symbol IYR. For more information on
                    the iShares MSCI EAFE, visit iShares.com and search ticker symbol EFA.
                    The launch date of the S&P 500 Risk Control 10% Index was April 4, 2013, and the launch
                    date of the S&P U.S. Retiree Spending Index was September 26, 2016.
                </b>
                )}
            </p>
        );

        label3 = (
            <div className="definition">
                {!isIAAndIAA && (
                    <React.Fragment>
                        <label>Participation rate </label>
                        <span>
                            A participation rate is the percentage of a positive index change that will be credited for a one-year term for an indexed strategy.
                        </span>
                    </React.Fragment>
                )}
            </div>
        );

        label4 = (
            <React.Fragment>
                <p>
                    The S&P 500 Index is a product of S&P Dow Jones Indices LLC or its affiliates ("SPDJI") and has been licensed for use by MassMutual Ascend Life Insurance Company. Standard & Poor's® and S&P® are registered trademarks of Standard & Poor's Financial Services LLC ("S&P"); Dow Jones® is a registered trademark of Dow Jones Trademark Holdings LLC ("Dow Jones"); and these trademarks have been licensed for use by SPDJI and sublicensed for certain purposes by MassMutual Ascend. MassMutual Ascend's products are not sponsored, endorsed, sold or promoted by SPDJI, Dow Jones, S&P, or their respective affiliates, and none of such parties makes any representation regarding the advisability of investing in such products nor do they have any liability for any errors, omissions, or interruptions of the S&P 500 Index.
                </p>

                <p>
                    The iShares MSCI EAFE ETF and the iShares U.S. Real Estate ETF are distributed by BlackRock Investments, LLC. iShares®, BLACKROCK®, and the corresponding logos are registered and unregistered trademarks of BlackRock, Inc. and its affiliates ("BlackRock"), and these trademarks have been licensed for certain purposes by MassMutual Ascend. MassMutual Ascend annuity products are not sponsored, endorsed, sold or promoted by BlackRock, and purchasers of an annuity from MassMutual Ascend do not acquire any interest in the iShares MSCI EAFE ETF or the iShares U.S. Real Estate ETF nor enter into any relationship of any kind with BlackRock. BlackRock makes no representation or warranty, express or implied, to the owners of any MassMutual Ascend annuity product or any member of the public regarding the advisability of purchasing an annuity, nor does it have any liability for any errors, omissions, interruptions or use of the iShares MSCI EAFE ETF or the iShares U.S. Real Estate ETF or any data related thereto.
                </p>
            </React.Fragment>
        );
    }else {
        label1 = (
            <React.Fragment>by a <b>cap.</b></React.Fragment>
        );

        label2 = (
            <b>
                For more information on the iShares MSCI EAFE, visit iShares.com and search ticker symbol EFA.
            </b>
        );
        label5 = (
            <div className="information">
                <p>
                    The S&P 500 Index is a product of S&P Dow Jones Indices LLC or its affiliates ("SPDJI") and has been licensed for use by MassMutual Ascend Life Insurance Company. Standard & Poor's® and S&P® are registered trademarks of Standard & Poor's Financial Services LLC ("S&P"); Dow Jones® is a registered trademark of Dow Jones Trademark Holdings LLC ("Dow Jones"); and these trademarks have been licensed for use by SPDJI and sublicensed for certain purposes by MassMutual Ascend. MassMutual Ascend's products are not sponsored, endorsed, sold or promoted by SPDJI, Dow Jones, S&P, or their respective affiliates, and none of such parties makes any representation regarding the advisability of investing in such products nor do they have any liability for any errors, omissions, or interruptions of the S&P 500 Index.
                </p>

                <p>
                    The iShares MSCI EAFE ETF and the iShares U.S. Real Estate ETF are distributed by BlackRock Investments, LLC. iShares<sup>®</sup>, BLACKROCK<sup>®</sup>, and the corresponding logos are registered and unregistered trademarks of BlackRock, Inc. and its affiliates ("BlackRock"), and these trademarks have been licensed for certain purposes by MassMutual Ascend. MassMutual Ascend annuity products are not sponsored, endorsed, sold or promoted by BlackRock, and purchasers of an annuity from MassMutual Ascend do not acquire any interest in the iShares MSCI EAFE ETF or the iShares U.S. Real Estate ETF nor enter into any relationship of any kind with BlackRock. BlackRock makes no representation or warranty, express or implied, to the owners of any MassMutual Ascend annuity product or any member of the public regarding the advisability of purchasing an annuity, nor does it have any liability for any errors, omissions, interruptions or use of the iShares MSCI EAFE ETF or the iShares U.S. Real Estate ETF or any data related thereto.
                </p>
            </div>
        );
    }

    return (
        <div className="Glossary">

            <div>

                <div>
                    <div className="definition">
                        <label>{getIndexProtectorLabel(props.indexProtector)}</label>
                        {!isIAAndIAA && (
                            <span>
                                A fee-based fixed-indexed annuity from MassMutual Ascend Life Insurance
                                Company available through fee-based advisors. The product offers <b>indexed strategies</b>.
                            </span>
                        )}
                        {isIAAndIAA && (
                            <span>
                                Registered index-linked annuity from MassMutual Ascend available through fee-based advisors. The product offers <b>indexed strategies</b>.
                            </span>
                        )}
                    </div>

                    <div className="definition">
                        <label>Declared Rate Strategy</label>
                        <span>
                            Money allocated to the declared rate strategy earns interest daily at a fixed rate that is set by the company at the
                            start of each term. You are not able to make hypothetical allocations to the declared rate strategy when using this calculator.
                        </span>
                    </div>

                    <div className="definition">
                        <label>Indexed strategies</label>
                        <span>
                           Money allocated to an indexed strategy earns interest based, in part, on the
                            positive performance of a market index or ETF. Interest is credited on the last day of
                            each {isIAAndIAA ? "" : "one-year"} term and is guaranteed to never be less than 0%. The amount of interest
                            credited is limited {label1}
                        </span>
                    </div>

                    <div className="information">
                        <p>
                            The {getIndexProtectorLabel(props.indexProtector)} offers <b>point-to-point</b> indexed
                            strategies based on the following indexes and ETF:
                        </p>

                        <ul>
                            <li>
                                S&P 500<sup>®</sup> Index – Seeks to track the investment results of an index composed of large-cap
                                equities of the 500 leading companies that captures approximately 80% coverage of
                                available market capitalization.
                            </li>
                            {notForWellsFargoContent}
                            <li>
                                iShares MSCI EAFE – Seeks to track the investment results of an index composed of
                                developed market equities, including those in Europe, Australia, Asia and the Far East
                            </li>
                            {is55MVA7 && (
                                <li>
                                    First Trust Barclays Edge Index: Seeks to provide equity and fixed income exposure
                                    through a blend of the Capital Strength Index and Value Line Dividend Index and
                                    Barclays' US 2-year Treasury Futures, 5-year Treasury Futures and 10-year Note Futures
                                    Indexes while aiming to control risk by maintaining a volatility target at or below 7%.
                                    Since the index is on an excess return basis (i.e., it returns the index performance in
                                    excess of risk-free rates), the risk free return is deducted from the equity underliers.
                                    The risk free rate used in this calculation is the U.S. Fed Funds Rate published by the
                                    Federal Reserve of New York (ticker: FEDL01) for each day divided by 360. No such
                                    adjustment is needed to the US Treasury futures indexes as these securities returns are
                                    naturally on an excess return basis.
                                </li>
                            )}
                            {isIAAndIAA && (
                                <li>
                                    SPDR Gold Shares ETF – Designed to reflect the market value of gold bullion
                                </li>
                            )}
                        </ul>

                        {label2}

                        {is55MVA7 && (
                            <React.Fragment>
                                <p>
                                    The First Trust Barclays Edge Index ("FTIS Index") is a product of FT Indexing
                                    Solutions LLC ("FTIS") and is administered and calculated by Bloomberg Index Service
                                    Limited and its affiliates (collectively, "BISL").  FIRST TRUST<sup>®</sup> and First Trust
                                    Barclays Edge Index are trademarks of First Trust Portfolios L.P. (collectively,
                                    with FTIS and their respective affiliates, "First Trust").  The foregoing index and
                                    trademarks have been licensed for use for certain purposes by Barclays, Bloomberg,
                                    and MassMutual Ascend Life Insurance Company (collectively, the "Licensees") in
                                    connection with the FTIS Index and certain products utilizing the FTIS Index
                                    (collectively, the "Products").
                                </p>

                                <p>
                                    The Capital Strength Index ("Nasdaq Index") is a product of Nasdaq, Inc.
                                    (collectively, with its affiliates, "Nasdaq"). NASDAQ<sup>®</sup>, CAPITAL STRENGTH INDEX<sup>TM</sup>,
                                    NQCAPST<sup>TM</sup>, and NQCAPSTT<sup>TM</sup> are trademarks of Nasdaq.  The
                                    foregoing index and trademarks have been licensed for use for certain purposes by
                                    FTI and Licensees in connection with the FTIS Index and the Products.
                                </p>

                                <p>
                                    The Value Line Dividend Index ("Value Line Index") is a product of Value Line, Inc.
                                    ("Value Line"). VALUE LINE<sup>®</sup> and VALUE LINE DIVIDEND INDEX<sup>TM</sup> are trademarks or
                                    registered trademarks of Value Line. The foregoing index and trademarks have been
                                    licensed for use for certain purposes by FTIS and Licensees in connection with the
                                    FTIS Index and the Products. The FTIS Index is not sponsored, endorsed, recommended,
                                    sold or promoted by Value Line and Value Line makes no representation regarding the
                                    advisability of investing in any product utilizing the FTIS Index.
                                </p>

                                <p>
                                    BLOOMBERG<sup>®</sup> is a trademark and service mark of Bloomberg Finance L.P.  Bloomberg
                                    Finance L.P., BISL, and their affiliates ("Bloomberg") are not affiliated with First
                                    Trust or Barclays.  Bloomberg's relationship to First Trust and Barclays is only (1)
                                    in the licensing of the FIRST TRUST<sup>®</sup>, BARCLAYS<sup>®</sup>, and FIRST TRUST BARCLAYS EDGE INDEX
                                    INDEX<sup>TM</sup> trademarks and (2) to act as the administrator and calculation
                                    agent of the FTIS Index, which is the property of FTIS.
                                </p>

                                <p>
                                    Bloomberg does not guarantee the timeliness, accurateness, or completeness of the
                                    FTIS Index or any data or information relating thereto and shall have no liability
                                    in connection with the FTIS Index or any data or information relating thereto.
                                </p>

                                <p>
                                    The Products are not issued, sponsored, endorsed, sold, recommended, or promoted by
                                    First Trust, Bloomberg, Nasdaq, Value Line, or their respective affiliates
                                    (collectively, the "Companies"). The Companies do not make any representation
                                    regarding the advisability of investing in the Products or products based on the
                                    FTIS Index, Barclays Indices, Nasdaq Index, or Value Line Index, do not make any
                                    warranties or bear any liability with respect to such products, and do not make any
                                    warranties or bear any liability with respect to the Products, the FTIS Index, or
                                    another party's index.
                                </p>

                                <p>
                                    THE COMPANIES DO NOT GUARANTEE THE ADEQUACY, ACCURACY, TIMELINESS, COMPLETENESS,
                                    AND/OR UNINTERRUPTED CALCULATION OF THE PRODUCTS, FTIS INDEX, BARCLAYS INDICES,
                                    NASDAQ INDEX, VALUE LINE INDEX, OR ANY DATA INCLUDED THEREIN OR ANY COMMUNICATION
                                    WITH RESPECT THERETO, INCLUDING, ORAL, WRITTEN, OR ELECTRONIC COMMUNICATIONS.  THE
                                    COMPANIES SHALL HAVE NO LIABILITY FOR ANY ERRORS, OMISSIONS, OR INTERRUPTIONS IN
                                    THE PRODUCTS, FTIS INDEX, BARCLAYS INDICES, NASDAQ INDEX, OR VALUE LINE INDEX.  THE
                                    COMPANIES MAKE NO WARRANTY, EXPRESS OR IMPLIED, AS TO THE RESULTS TO BE OBTAINED BY
                                    LICENSEES, OWNERS OF THE PRODUCTS OR OF PRODUCTS BASED ON THE FTIS INDEX, BARCLAYS
                                    INDICES, NASDAQ INDEX, OR VALUE LINE INDEX, OR BY ANY OTHER PERSON OR ENTITY FROM
                                    THE USE OF THE FTIS INDEX, BARCLAYS INDICES, NASDAQ INDEX, OR VALUE LINE INDEX, OR
                                    ANY DATA INCLUDED THEREIN.
                                </p>

                                <p>
                                    Neither Barclays Bank PLC ('<b>BB PLC</b>') nor any of its affiliates
                                    (collectively'<b>Barclays</b>') is the issuer or producer of MassMutual Ascend's products
                                    and Barclays has no responsibilities, obligations or duties to investors in
                                    MassMutual Ascend's products. The Barclays US 2Y Treasury Futures Index, Barclays
                                    US 5Y Treasury Futures Index, Barclays US 10Y Note Index, and Barclays Switch USD
                                    Signal Index (collectively, the "<b>Indices</b>"), together with any Barclays
                                    indices that are components of the Indices, are trademarks owned by Barclays and,
                                    together with any component indices and index data, are licensed for use by FTIS in
                                    connection with the First Trust Barclays Edge Index.
                                </p>

                                <p>
                                    Barclays' only relationship with the MassMutual Ascend in respect of the Indices
                                    is the licensing of the Indices to FTIS, which are administered, compiled and
                                    published by BB PLC in its role as the index sponsor (the '<b>Index Sponsor</b>')
                                    without regard to MassMutual Ascend's products  or investors in MassMutual Ascend's
                                    products. Additionally, MassMutual Ascend as issuer or producer of MassMutual
                                    Ascend's products  may for itself execute transaction(s) with Barclays in or
                                    relating to the Indices in connection with MassMutual Ascend's products. Investors
                                    acquire MassMutual Ascend's products from MassMutual Ascend and investors neither
                                    acquire any interest in the Indices nor enter into any relationship of any kind
                                    whatsoever with Barclays upon making an investment in MassMutual Ascend's products .
                                    MassMutual Ascend's products  are not sponsored, endorsed, sold or promoted by
                                    Barclays and Barclays makes no representation regarding the advisability of MassMutual
                                    Ascend's products  or use of the Indices or any data included therein. Barclays shall
                                    not be liable in any way to MassMutual Ascend, investors or to other third parties
                                    in respect of the use or accuracy of the Indices or any data included therein.
                                </p>
                            </React.Fragment>
                        )}

                        <p>
                            Returns prior to the index launch date are back-tested. Back-tested performance is not
                            actual performance, but is hypothetical. Back-tested returns were calculated using the same
                            methodology that was in effect when the index was officially launched. Back-tested
                            performance is subject to inherent limitations because it reflects application of an index
                            methodology and selection of index constituents in hindsight. No theoretical approach can
                            take into account all of the factors in the markets in general and the impact of decisions
                            that might have been made during the actual operation of an index. Historical and
                            back-tested returns are not indicative of the interest that would have been credited to a
                            fixed-indexed annuity during the same time period.
                        </p>

                        {label3}
                    </div>

                    {label5}

                    <div className="definition">
                        <label>Point-to-point indexed strategy </label>
                        <span>
                            A point-to-point indexed strategy compares the closing value of the index or ETF at the
                            end of a one-year term to the closing value on the fi rst day of the term. If the result
                            is positive, interest is credited. If the result is negative, the credited interest rate
                            is 0%.
                        </span>
                    </div>

                    <div className="definition">
                        <label>Cap</label>
                        <span>
                            A cap is the maximum interest rate that will be credited for a term for an indexed strategy.
                        </span>
                    </div>

                    {isIAAndIAA && (
                        <React.Fragment>
                            <div className="definition">
                                <label>Upside participation rate</label>
                                <span>
                                    An upside participation rate is the percentage of a positive index change that will be credited for a term for an indexed strategy.
                                </span>
                            </div>

                            <div className="definition">
                                <label>Floor</label>
                                <span>
                                    A floor is the largest negative index change that is used to determine a loss at the end of a term for an indexed strategy. The -10% floor indexed strategies provide protection against index losses in excess of -10% at the end of each term.
                                </span>
                            </div>

                            <div className="definition">
                                <label>Downside participation rate</label>
                                <span>
                                    A downside participation rate is the percentage of any negative index change that is taken into account to determine a loss at the end of a term for an indexed strategy. The 50% downside participation rate indexed strategies provide protection against 50% of index losses at the end of each term.
                                </span>
                            </div>

                            <div className="definition">
                                <label>Buffer</label>
                                <span>
                                    A buffer is the portion of a negative index change that is disregarded to determine a loss at the end of a term for an indexed strategy. The 10% buffer indexed strategies provide protection against the first 10% of index losses at the end of each term.
                                </span>
                            </div>
                        </React.Fragment>
                    )}

                    {label4}

                </div>


                <div>
                    <h2>Metrics</h2>

                    <div className="definition">
                        <label>Average Return:</label>
                        <span>Average of random returns generated by the plan across all simulations.</span>
                    </div>

                    <div className="definition">
                        <label>Standard Deviation:</label>
                        <span>Based on random returns generated across all simulations, it is a measure of the dispersion from the average.</span>
                    </div>

                    <div className="definition">
                        <label>Sharpe Ratio:</label>
                        <span>Risk-adjusted return based on total standard deviation.</span>
                    </div>

                    <div className="definition">
                        <label>Sortino Ratio:</label>
                        <span>Risk-adjusted return based on downside deviation only.  Downside deviation is the standard deviation of returns that are less than the Minimally Acceptable Return (MAR).  MAR is currently 3.12% and is based on annual inflation rates between December 2015 and December 2025</span>
                    </div>

                </div>

                <div>
                    <h2>Market Conditions</h2>
                    <p>
                        Equity Market Conditions: Based on historical index returns from 1/1/2016 to 12/31/2025
                    </p>

                    <div className="definition">
                        <label>Bear:</label>
                        <span>10th percentile of historical returns.</span>
                    </div>

                    <div className="definition">
                        <label>Little Bear:</label>
                        <span>25th percentile of historical returns.</span>
                    </div>

                    <div className="definition">
                        <label>Normal:</label>
                        <span>Average of historical returns.</span>
                    </div>

                    <div className="definition">
                        <label>Little Bull:</label>
                        <span>75th percentile of historical returns.</span>
                    </div>

                    <div className="definition">
                        <label>Bull:</label>
                        <span>90th percentile of historical returns.</span>
                    </div>

                </div>

                <div>
                    <p>
                        Fixed-Income Market Conditions: Based on the average yield-to-maturity of a benchmark fund, adjusted for duration and convexity, along with interest rate movement assumptions and historical index returns from 1/1/2016 to 12/31/2025.
                    </p>

                    <div className="definition">
                        <label>Bear:</label>
                        <span>Benchmark Fund's average Yield to Maturity, adjusted for duration and convexity, incorporating the effects of a 300 bps interest rate increase.</span>
                    </div>

                    <div className="definition">
                        <label>Little Bear:</label>
                        <span>Benchmark Fund's average Yield to Maturity, adjusted for duration and convexity, incorporating the effects of a 150 bps interest rate increase.</span>
                    </div>

                    <div className="definition">
                        <label>Normal:</label>
                        <span>Benchmark Fund's Yield to Maturity</span>
                    </div>

                    <div className="definition">
                        <label>Little Bull:</label>
                        <span>Benchmark Fund's average Yield to Maturity, adjusted for duration and convexity, incorporating the effects of a 150 bps interest rate decrease.</span>
                    </div>

                    <div className="definition">
                        <label>Bull:</label>
                        <span>Benchmark Fund's average Yield to Maturity, adjusted for duration and convexity, incorporating the effects of a 300 bps interest rate decrease.</span>
                    </div>

                </div>

            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        companyName: state.globalState.companyName
    }
};

export default connect(mapStateToProps)(glossary);



// WEBPACK FOOTER //
// ./src/components/Glossary/Glossary.js